componentRegistryInstance.register('time', 'edit', 'hrd.components.form.TimeComponent');

hrd.components.form.TimeComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.TimeComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, `${klass} ignore-on-blur`);
		this.timeOptions = this.utils().time().options(field.data('format'));
		if (field.data('showOn')) {
			this.timeOptions.showOn = field.data('showOn') || 'button';
		}
		field.timepicker(this.timeOptions).addClass('center-align');
		field.parent().css('white-space', 'nowrap'); // used to avoid calendar icon on new line

		$.timeout(300)
			.then(() => this._postEnhance(field));

		/*
		 * use this and not the one defined in 'AbstractDashboard.postLoadExec()' 
		 * Needed in order to have a properly format time 
		*/
		field.on('change', () => {
			let currentValue = field.val();
			field.val(hrd.utils.formatTime(currentValue));
		})
	},

	_postEnhance: function(field) {
		if (this.timeOptions.showOn === 'off') return;

		if (!field.usingChromaFlow()) return;

		let customPosition = undefined;
		if (field.data('custom-position') == true) {
			let fnCustomPosition = $.functionCase(field.data('name') + '-custom-position');
			if (this.settings.reference && typeof this.settings.reference[fnCustomPosition] == 'function') {
				customPosition = this.settings.reference[fnCustomPosition].call(this.settings.reference, field, this.getFormInstance());
			} else {
				console.log(`function "${fnCustomPosition}" not available in proper object reference "${this.settings.reference._FULL_}". Add it in order to configure "custom position" for date picker properly`);
			}
		}

		const $trigger = this.getTrigger(field);

		$trigger.attr('data-variants', 'timepicker-addon');

		this.wrapForTimepickerAddon(field);

		const $datepicker = this.toolbox.get('datepicker.dpDiv', field.data());

		$datepicker
			.addClass('popover closed')
			.attr('data-state', 'closed');

		let position = $.extend({
			my: 'center top',
			at: 'center bottom',
			of: field,
		}, customPosition);

		switch (this.timeOptions.showOn) {
			case 'button':
				this.datePickerButtonHandler($trigger, $datepicker, position);
				break;
			case 'focus':
				this.datePickerFocusHandler(field, $datepicker, position);
				break;
			case 'both':
				this.datePickerButtonHandler($trigger, $datepicker, position);
				this.datePickerFocusHandler(field, $datepicker, position);
				break;
		}
		this.datePickerCloseHandler();
	},
	getEditableField: function(field, name, object, options) {
		this._super(field, name, object, options);
	},

	setEditableField: function(field, value, object, options) {
		if (typeof value === 'string') {
			field.val(value);
		} else {
			field.timepicker().datetimepicker('setDate', value);
		}
	},
	initalizeComponent: function(field, initialValue) {
		var time;
		var sFormat = field.data('format');
		if (initialValue === 'customFn') {
			var customFn = $.functionCase(field.data('name') + '-init-field');
			var t;
			if (this.settings.reference && typeof this.settings.reference[customFn] === 'function') {
				t = this.settings.reference[customFn].call(this.settings.reference, field, this.getFormInstance());
			} else {
				if (this.settings.reference) {
					console.log(`InitField function NOT available. Add "${customFn}" in "${this.settings.reference._FULL_}"`);
				}
				t = field.triggerHandler('init-time-field');
			}
			time = this.utils().time().timeFormat(t, sFormat);
		} else {
			time = this.utils().time().patternToTime(initialValue, sFormat);
		}
		field.val(time);
	},

	resetEditableField: function(field, options) {
		/* as of now i do not find any reset method on timepicker. 
		 * so i destroy and re-enhance it again
		 */
		field.val('');
		field.timepicker('destroy');
		this.getFormInstance().enhanceEditField(field);
	},

	/**
	 * Disable Field
	 */
	disableField: function(field, disable) {
		let method = disable ? 'disable' : 'enable';
		field.datepicker(method);
		this.getTrigger(field).button(method);
	},
	
	wrapForTimepickerAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		const $addon = field.closest('.field-composite').find('[data-variants~="timepicker-addon"]');
		if ($addon.exists() && !$addon.closest('.addon-container').exists()) {
			$addon
				.add($addon.siblings('.field-container, .editable-data, .read-only-data'))
				.wrapAll('<div class="timepicker-addon-container addon-container field-container"></div>');
		}

		if ($addon.exists()) {
			if ($addon.nextAll(field).exists()) {
				$addon.addClass('addon-before');
				field.addClass('addon-after');
			} else if ($addon.prevAll(field).exists()) {
				field.addClass('addon-before');
				$addon.addClass('addon-after');
			}
		}
	},
	getTrigger: function(field) {
		const $trigger = field.closest('.field-composite').find('.ui-datepicker-trigger');
		return $trigger;
	},
	datePickerButtonHandler: function($trigger, $datepicker, position) {
		$trigger
			.off('.open-datepicker')
			.on('click.open-datepicker', () => {
				$datepicker
					.addClass('ui-timepicker ui-helper-hidden-invisible')
					.removeClass('closed')
					.attr('data-state', 'open')
					.css({
						top: 'unset',
						left: 'unset',
						right: 'unset',
						bottom: 'unset',
					})
					.position(position);

				$datepicker
					.addClass('closed')
					.attr('data-state', 'closed')
					.removeClass('ui-helper-hidden-invisible');

				$datepicker
					.css({
						opacity: 1
					})
					.stop(true)
					.removeClass('closed')
					.attr('data-state', 'open');
			});
	},
	datePickerFocusHandler: function($trigger, $datepicker, position) {
		$trigger
			.off('.open-datepicker')
			.on('focus.open-datepicker', () => {
				$datepicker
					.addClass('ui-timepicker ui-helper-hidden-invisible')
					.removeClass('closed')
					.attr('data-state', 'open')
					.css({
						top: 'unset',
						left: 'unset',
						right: 'unset',
						bottom: 'unset',
					})
					.position(position);

				$datepicker
					.addClass('closed')
					.attr('data-state', 'closed')
					.removeClass('ui-helper-hidden-invisible');

				$datepicker
					.css({
						opacity: 1
					})
					.stop(true)
					.removeClass('closed')
					.attr('data-state', 'open');
			});
	},
	datePickerCloseHandler: function() {
		let isAlreadyRegistered = $(document).hasEvent('click', 'close-timepicker');
		if (!isAlreadyRegistered) {
			$(document)
				.off('click.close-timepicker')
				.on('click.close-timepicker', (evt) => {
					if (
						$(evt.target).is('.hasDatepicker') ||
						$(evt.target).closest('.hasDatepicker').exists() ||
						$(evt.target).closest('.ui-datepicker').exists() ||
						$(evt.target).closest('.ui-datepicker-prev').exists() ||
						$(evt.target).closest('.ui-datepicker-next').exists()
					) return;

					$('.ui-timepicker')
						.stop(true)
						.attr('data-state', 'closed');

					$('.ui-timepicker')
						.off('.animation')
						.on('animationend.animation', (event) => {
							event.stopPropagation();

							const isClosed = $(event.target).attr('data-state') === 'closed';
							$(event.target)
								.toggleClass('closed', isClosed);


							if (isClosed) {
								$(event.target)
									.css({
										top: 'unset',
										left: 'unset',
										right: 'unset',
										bottom: 'unset',
									});
							}
						});
				});
		}
	}
});